
const newModel = () => {
    return {
        vanhoaDitichDisanId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        phuongXaId: null,
        tenPhuongXa: null,
        diaChi: null,
        soQuyenDinh: null,
        ngayCongNhan: null,
        namCongNhan: null,
        hoSo: null,
        linkHoSo: null,
        tenFileHoSo: null,
        loaiDitichId: null,
        tenLoaiDitich: null,
        loaihinhDitichId: null,
        tenLoaihinhDitich: null,
        vanhoaDiemDuLichId: null,
        tenVanhoaDiemDuLich: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        web: null,
        gioiThieu: null,
        ghiChu: null,
        stt: null,
        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
        
    }
}

const newFEModel = () => {
    return {
        vanhoaDitichDisanId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        quanHuyenId: null,
        tenQuanHuyen: null,
        phuongXaId: null,
        diaChi: null,
        soQuyenDinh: null,
        ngayCongNhan: null,
        namCongNhan: null,
        hoSo: null,
        linkHoSo: null,
        tenFileHoSo: null,
        loaiDitichId: null,
        loaihinhDitichId: null,
        vanhoaDiemDuLichId: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        web: null,
        gioiThieu: null,
        ghiChu: null,
        stt: "0",
        fListHinhAnh: null, //PostValue
        fileHinhAnhInfo: [], //GetValue
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        vanhoaDitichDisanId: item.vanhoaDitichDisanId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        quanHuyenId: item.quanHuyenId,
        tenQuanHuyen: item.tenQuanHuyen,
        phuongXaId: item.phuongXaId,
        tenPhuongXa: item.tenPhuongXa,
        diaChi: item.diaChi,
        soQuyenDinh: item.soQuyenDinh,
        ngayCongNhan: item.ngayCongNhan,
        namCongNhan: item.namCongNhan,
        hoSo: item.hoSo,
        linkHoSo: item.linkHoSo,
        tenFileHoSo: item.tenFileHoSo,
        loaiDitichId: item.loaiDitichId,
        tenLoaiDitich: item.tenLoaiDitich,
        loaihinhDitichId: item.loaihinhDitichId,
        tenLoaihinhDitich: item.tenLoaihinhDitich,
        vanhoaDiemDuLichId: item.vanhoaDiemDuLichId,
        tenVanhoaDiemDuLich: item.tenVanhoaDiemDuLich,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        web: item.web,
        gioiThieu: item.gioiThieu,
        ghiChu: item.ghiChu,
        stt: item.stt,
        fListHinhAnh: item.fListHinhAnh,
        fileHinhAnhInfo: item.fileHinhAnhInfo,
        xoaListHinhAnh: item.xoaListHinhAnh,
        enabled: item.enabled,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocDateUpdated: item.iocDateUpdated,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        vanhoaDitichDisanId: item.vanhoaDitichDisanId,
        ten: item.ten,
        hinhAnh: item.hinhAnh,
        linkHinhAnh: item.linkHinhAnh,
        tenFileHinhAnh: item.tenFileHinhAnh,
        quanHuyenId: item.quanHuyenId,
        phuongXaId: item.phuongXaId,
        diaChi: item.diaChi,
        soQuyenDinh: item.soQuyenDinh,
        ngayCongNhan: item.ngayCongNhan,
        namCongNhan: item.namCongNhan,
        hoSo: item.hoSo,
        linkHoSo: item.linkHoSo,
        tenFileHoSo: item.tenFileHoSo,
        loaiDitichId: item.loaiDitichId,
        loaihinhDitichId: item.loaihinhDitichId,
        vanhoaDiemDuLichId: item.vanhoaDiemDuLichId,
        gpsLong: item.gpsLong,
        gpsLat: item.gpsLat,
        sdt: item.sdt,
        web: item.web,
        gioiThieu: item.gioiThieu,
        ghiChu: item.ghiChu,
        stt: item.stt,
        fListHinhAnh: item.fListHinhAnh,
        fileHinhAnhInfo: item.fileHinhAnhInfo,
        xoaListHinhAnh: item.xoaListHinhAnh,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        vanhoaDitichDisanId: null,
        ten: null,
        hinhAnh: null,
        linkHinhAnh: null,
        tenFileHinhAnh: null,
        quanHuyenId: null,
        phuongXaId: null,
        loaiDitichId: null,
        loaihinhDitichId: null,
        vanhoaDiemDuLichId: null,
        diaChi: null,
        soQuyenDinh: null,
        ngayCongNhan: null,
        namCongNhan: null,
        hoSo: null,
        linkHoSo: null,
        tenFileHoSo: null,
        gpsLong: null,
        gpsLat: null,
        sdt: null,
        web: null,
        gioiThieu: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ngayCongNhanTungay: null,
        ngayCongNhanDenngay: null,
        phuongXaId: null,
        loaiDitichId: null,
        loaihinhDitichId: null,
        vanhoaDiemDuLichId: null,
        enabled: null,
    }
}

const newSearchModel = () => {
    return {
        ngayCongNhanTungay: null,
        ngayCongNhanDenngay: null,
        phuongXaId: null,
        loaiDitichId: null,
        loaihinhDitichId: null,
        vanhoaDiemDuLichId: null,
        enabled: null,
    }
}

export const diTichDiSanVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


